import { CdkScrollable } from '@angular/cdk/overlay';
import {
  Component, Input, ContentChild, TemplateRef, HostBinding, ViewChild, AfterViewInit, OnDestroy, EventEmitter, NgZone, Output
} from '@angular/core';
import { takeUntil, startWith } from 'rxjs/operators';

@Component({
  selector: 'sondermind-card-carousel',
  templateUrl: './card-carousel.component.html',
  standalone: false
})
export class CardCarouselComponent implements AfterViewInit, OnDestroy {
  private destroyed$ = new EventEmitter<void>();

  @HostBinding('class.sondermind-card-carousel')
    bindClass = true;

  // defaults to left, since that's likely where it starts
  // we clean this up after view init
  @HostBinding('attr.data-flush')
    flush = 'left';

  @Input()
  @HostBinding('attr.data-shadows')
    shadows = true;

  @Input() data: any[];

  @ContentChild(TemplateRef)
    template!: TemplateRef<any>;

  @ContentChild('header', { read: TemplateRef })
    headerTemplate?: TemplateRef<any>;

  @ContentChild('footer', { read: TemplateRef })
    footerTemplate?: TemplateRef<any>;

  @ViewChild(CdkScrollable)
    scrollable: CdkScrollable;

  @Output()
    navigated = new EventEmitter<any>();

  constructor(
    private zone: NgZone,
  ) {}

  ngAfterViewInit() {
    this.installScrollingHandlers();
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }

  // rows

  rowContext(row: any, index: number, count: number) {
    return {
      $implicit: row, carousel: this, index, count
    };
  }

  // scroll handling for shadows

  installScrollingHandlers() {
    this.scrollable.elementScrolled()
      .pipe(
        takeUntil(this.destroyed$),
        startWith(null)
      )
      .subscribe(() => this.onCarouselScrolled());
  }

  onCarouselScrolled() {
    // this will be run from outside the zone
    // since the scrollable #elementScrolled observable is triggered outside the zone

    const offsetLeft = this.scrollable.measureScrollOffset('left');
    const offsetRight = this.scrollable.measureScrollOffset('right');
    const parts = [];

    if (offsetLeft === 0) {
      parts.push('left');
    }

    if (offsetRight === 0) {
      parts.push('right');
    }

    const flush = parts.join(' ');
    if (this.flush == null || this.flush !== flush) {
      // eslint-disable-next-line no-return-assign
      this.zone.run(() => this.flush = flush);
    }
  }

  // navigable
  // a card list is navigable if something is observing (navigated)

  get isNavigable() {
    return this.navigated.observers.length > 0;
  }

  navigateToRow(row: any) {
    this.navigated.next(row);
  }
}

export const Declarations = [
  CardCarouselComponent
];
